/**
 * 用于加载地图的代理对象。
 * 
 * new BMapProxy(container).then((m,v,gl) = {
 *  // m 是BMapGL的map对象，是核心地图组件（参见Baidu地图开放平台）
 *  // v 是view对象，用于呈现mapv图层（炫酷特效和数据可视化）
 *  // gl是BMapGL对象本身
 * })
 */
import * as mapvgl from 'mapvgl'
// import yanmouStyle from '@/common/bmap.style.yanmou.js'
import loadBMapGL from '@/common/BMapGL.js'

/**
 * 用于加载地图的代理对象。
 * 
 * new BMapProxy(container).then((m,v,gl) = {
 *  // m 是BMapGL的map对象，是核心地图组件（参见Baidu地图开放平台）
 *  // v 是view对象，用于呈现mapv图层（炫酷特效和数据可视化）
 *  // gl是BMapGL对象本身
 * })
 * 
 * @param {*} container 用于装载地图的dom组件id，通常是个div
 * @returns 
 */
export default function BMapProxy() {
  var BMapGL = undefined
  var map = undefined
  var view = undefined

  /**
   * 
   * @param {*} container 
   * @returns 
   */
  this.init = function (container) {
    return new Promise(resolve => {
      loadBMapGL().then((gl) => {
        BMapGL = gl
        map = new BMapGL.Map(container, {
          minZoom: 10.8,
          maxZoom: 18.8,
          // style: {          styleJson: yanmouStyle}
        })
        map.enableScrollWheelZoom()
        map.centerAndZoom(new BMapGL.Point(117.18, 32.12), 13)
        view = new mapvgl.View({
          map: map,
        })

        // map.setMapType(BMAP_EARTH_MAP)

        resolve(map,view)
      })
    })

  }

    /**
   * 初始化地图，得到map对象
   * @param {*} container 
   * @returns 
   */
  this.init = function (container) {
    return new Promise(resolve => {
      loadBMapGL().then((gl) => {
        BMapGL = gl
        map = new BMapGL.Map(container, {
          minZoom: 10.8,
          maxZoom: 18.8,
          // style: {          styleJson: yanmouStyle}
        })
        map.enableScrollWheelZoom()
        map.centerAndZoom(new BMapGL.Point(117.18, 32.12), 13)
        resolve(map)
      })
    })
  }

  /**
   * 初始化地图，得到map和view对象
   * @param {dom} container 
   * @returns 
   */
  this.init2 = function (container) {
    return new Promise(resolve => {
      loadBMapGL().then((gl) => {
        BMapGL = gl
        map = new BMapGL.Map(container,{
            minZoom: 10.8,
            maxZoom: 18.8,
            // style: {          styleJson: yanmouStyle}
          })
        map.enableScrollWheelZoom()
        view = new mapvgl.View({
          map: map,
        })

        // map.setMapType(BMAP_EARTH_MAP)
      // map.setMapStyleV2(BMAP_EARTH_MAP)
        resolve({
          map,
          view
        })
      })
    })
  }
  /**
   * 提供了一个快捷的工具方法（业务代码中不需要重复写这些代码），帮助地图视口切换到一个新的位置和新的zoom。options支持heading和tilt设置
   * 
   * @param {*} lng 
   * @param {*} lat 
   * @param {*} zoom 
   * @param {*} options 
   * @returns 
   */
  this.fly2 = function (lng, lat, zoom, options) {
    return new Promise(resolve => {
      let opt = Object.assign({
        callback: () => {
          resolve()
        }
      }, options ? options : {})
      map.flyTo(new BMapGL.Point(lng, lat), zoom, opt)
    })
  }





}



// WEBPACK FOOTER //
// ./src/common/BMapProxy.js